import React from 'react'
import { TypeAnimation } from 'react-type-animation';
import './intro.css'
import Github from '../../img/github.png'
import LinkedIn from '../../img/linkedin.png'
import Instagram from '../../img/instagram.png'
import profile from '../../img/profile.png'
import thumbup from '../../img/thumbup.png'
import crown from '../../img/crown.png'
import glassesimoji from '../../img/glassesimoji.png'
import Floating from '../Floating/Floating';
import { useContext } from "react";
import { themeContext } from '../../Context';

const Intro =() => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

  return (
    <div className="intro">
        <div className="i-left">
            <div className="i-name">
                <span style = {{color : darkMode? 'white': ''}}>Hi! I Am </span>
                <span>Benjamin-David Dawson</span>
            </div>
            <div className="i-anim">
            <TypeAnimation
                // Same String at the start will only be typed once, initially
                sequence={[
                'A Software Engineer',
                1000,
                'A Front-End Developer',
                1000,
                'A Backend-End Developer',
                1000,
                'A 3D Modeler & Animator',
                1000,
                ]}
                speed={50} // Custom Speed from 1-99 - Default Speed: 40
                style={{ fontSize: '2em' , color : darkMode? 'white': ''}}
                wrapper="span" // Animation will be rendered as a <span>
                repeat={Infinity} // Repeat this Animation Sequence infinitely
            />
            </div>

            <button className="button i-button">Hire me</button>

            <div className="i-icons">
                <a href='https://github.com/lmy-dawson' target={'_blank'} rel="noopener noreferrer"><img src={Github} alt="" /></a>
                <a href='https://www.linkedin.com/in/benjamin-david-dawson-2498261a3/' target={'_blank'} rel="noopener noreferrer"><img src={LinkedIn} alt="" /></a>
                <a href='https://www.instagram.com/realteamsasuke/' target={'_blank'} rel="noopener noreferrer"><img src={Instagram} alt="" /></a>
            </div>
        </div>



        <div className="i-right">
        <img src={profile} alt="" />
        <img src={glassesimoji} alt="" />
        <div style={{top: '6rem', left: '70%'}}>
            <Floating className='floating-div' image={crown} txt1='Web' txt2='Developer'/>
        </div>
        <div style={{top: '17rem', left: '4%'}}>
            <Floating className='floating-div' image={thumbup} txt1 = '3D' txt2 = 'Modeler & Animator'/>
        </div>
        {/*blur background divs */}
        <div className="blur" style={{background: "rgb(238 210 255)"}}></div>

        <div className="blur" style={{
        background: '#C1F5FF',
        top: '17rem',
        width: '21rem',
        height: '11rem',
        left: '-9rem'
        }}></div>

        </div>
    </div>
  )
}

export default Intro